import React, { useState, useEffect } from 'react';
import './Header.css';
import GemLogo from "../assets/img/HeaderImages/gemlogo.png";
import gemlogo from "../assets/img/HeaderImages/GEM-LOGO.png";
// import gemlogo from "../assets/img/HeaderImages/gem-jo-icon.png";
import call from "../assets/img/HeaderImages/call.png";
import Letter from "../assets/img/HeaderImages/Letter.png";
import { NavLink } from 'react-router-dom';
import ecatelogue from '../assets/img/HeaderImages/ecatelog.jpg';
import cloud from '../assets/img/HeaderImages/cloud.jpg';
import gemnew from "../assets/img/HeaderImages/logonew-min blue eeee.png";

import cloud1 from "../assets/img/HeaderImages/cloud1.png"
import LogoWhite from "../assets/img/HeaderImages/logonew-min blue eeee.png"
import catalogue from "../assets/Catalogue/gem-jo.pdf"
import { AiOutlineCaretDown } from "react-icons/ai";
import { Menu, MenuItem } from "@mui/material";
import { ChevronDown } from "lucide-react";
import useMediaQuery from "@mui/material/useMediaQuery";
import calling from "../assets/img/HeaderImages/calling.png"
import Vector from "../assets/img/HeaderImages/Vector.png"
import favcon from "../assets/img/HeaderImages/logonew-full white.png"


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLeftLogo, setShowLeftLogo] = useState(false);
  const [productsDropdownOpen, setProductsDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    if (isMobile) setIsOpen(!isOpen);
  };

  const [middlefix, setmiddlefix] = useState(false);

  const [isScrolled, setIsScrolled] = useState(false);

  const toggleProductsDropdown = () => {
    setProductsDropdownOpen(!productsDropdownOpen);
  };
  

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {

        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  console.log("isScrolled", isScrolled)
  // Scroll detection logic
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowLeftLogo(true);
      } else {

        setShowLeftLogo(false);
      }
      if (window.scrollY > 80) {
        setmiddlefix(true);
      } else {
        setmiddlefix(false);
      }
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);


  return (
    <header className="header">
      <div className="header-top">
        {/* Logo */}
        <div className="header-logo1">
          <img src={GemLogo} alt="Company Logo" className="logo" />
          <img src={gemlogo} alt="Company Logo" className="gemlogo" />

        </div>
        {window.innerWidth < 768 && (
         <div className='mobile-logo' style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
         {/* Clickable Call Icon */}
         <img 
           src={calling} 
           alt="Call Icon" 
           style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
           onClick={() => window.open(`https://wa.me/962791008716`, "_blank")}  
         />
       
         {/* Clickable Email Icon */}
         <a href="mailto:info@gemplay.com.jo">
           <img 
             src={Vector} 
             alt="Email Icon" 
             style={{ width: '20px', height: '20px', cursor: 'pointer' }} 
           />
         </a>
       </div>
       
        )}

        {/* Contact Info */}
        <div className="header-logo2">
        <div className="contact-logo">
    {/* Clickable call icon */}
    <img 
      src={call} 
      alt="Call Icon" 
      className="logo" onClick={() => window.open(`https://wa.me/962791008716`, "_blank")} 
      style={{ cursor: "pointer" }} 
    />

    {/* Clickable phone number */}
    <span 
      className="call-number" 
      onClick={() => window.open(`https://wa.me/962791008716`, "_blank")}
      style={{ cursor: "pointer" }} 
    >
      +962791008716
    </span>
  </div>
          {/* <div className="contact-logo"><img src={Letter} alt="Email Icon" className="logo" />
          <span className="email">info@gem-jo.com</span></div>
        </div> */}

          <div className="contact-logo">
            <img src={Letter} alt="Email Icon" className="logo" />
            <a href="mailto:info@gemplay.com.jo" className='email-link'>info@gemplay.com.jo</a>
          </div>
        </div>


        <a href={catalogue} className="download-button" download='Catalogue'>
          Download Catalogue
          {/* <img src={cloud1} alt="cloud button" className="icon" /> */}
        </a>



        {/* <div className="e-catalogue-button-container">
        <img src={ecatelogue} alt="catelogue button" className="e-catalogue-button" />
      </div> */}

        <div style={{ gap: "2%", paddingLeft: "0%", paddingRight: "4%" }} className="cloud-button-container">
          <a href={catalogue} download='Catalogue'>
          <img src={cloud} alt="cloud button" className="cloud-button" />
          </a>

          {/* </a> */}
        </div>



        <div
          className="mobile-menu"
          style={{
            position: "absolute",
            // top: isScrolled ? "0" : "auto",
            // left: "0",
            width: "100%",
            height:  "5.5%",
            backgroundColor: "#d0064b",
            zIndex: "1000",
            transition: "top 0.05s ease-in-out",
            padding: "3% 0%",
          }}
        >
          {/* Hamburger Menu for Mobile */}
          <div className="H-M-Logo" >
            
            <img src={LogoWhite} alt="Nav-logo" className="LogoWhite" />
          </div>
          <button className="hamburger-menu" onClick={toggleMenu} aria-label="Toggle Navigation">
            ☰
          </button>


        
        </div>
          {/* Mobile Navigation Menu */}
           <div className="fullscreen-menu"
        style={{
          position: "fixed",
          top: isOpen ? "0" : "-100%", // slide in/out effect
          left: "0",
          width: "100%",
          height: "100%", // Full screen
         backgroundColor: "rgba(255, 255, 255, 0.95)", // Slight transparency,
          boxShadow: "0px 2px 10px rgba(0,0,0,0.1)",
          zIndex: 2147483647,
           transform: "translate3d(0,0,0)",
          transition: "top 0.4s ease",
          overflowY: "auto",
          WebkitTransform: "translate3d(0,0,0)",
        }}
      >
            {/* Close Button */}
           <button
                  onClick={toggleMenu}
                  aria-label="Close Menu"
                  style={{
                    position: "absolute",
                    top: "24px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: "39px",
                    height: "39px",
                    borderRadius: "50%",
                    border: "1px solid #aaa",
                    backgroundColor: "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    zIndex: "1001",
                    padding: 0, // Ensure no extra spacing
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#333"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>

            {/* Menu Items */}
            <ul style={{
              listStyle: "none", padding: "3px 0", margin: "0", textAlign: "center", width: "100%", marginTop: "40%" // Full width
            }}>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "500",
                fontSize: "18px",
                lineHeight: "24px",
                letterSpacing: "0%",
                color: "#0A1229",
                textDecoration: "none"

              }}>
                <NavLink
                  to="/"
                  style={{ textDecoration: "none", color: "#0A1229" }}
                  activeStyle={{ fontWeight: "bold" }}
                >
                  Home 
                </NavLink>
              </li>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0%"
              }}>
                <NavLink
                  to="/About"
                  style={{ textDecoration: "none", color: "#0A1229" }}
                  activeStyle={{ fontWeight: "bold" }}
                >About</NavLink>
              </li>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0%"
              }}>
                <NavLink to="/Products"
                  style={{ textDecoration: "none", color: "#0A1229" }}
                  activeStyle={{ fontWeight: "bold" }}
                >Products</NavLink>
              </li>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0%"
              }}>
                <NavLink to="/Projects"
                  style={{ textDecoration: "none", color: "#0A1229" }}
                  activeStyle={{ fontWeight: "bold" }}
                >Projects</NavLink>
              </li>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0%"
              }}>
                <NavLink to="/Roadmap"
                  style={{ textDecoration: "none", color: "#0A1229" }}
                  activeStyle={{ fontWeight: "bold" }}
                >Roadmap</NavLink>
              </li>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0%"
              }}>
                <NavLink to="/Blog"
                  style={{ textDecoration: "none", color: "#0A1229"}}
                  activeStyle={{ fontWeight: "bold" }}
                >Blog</NavLink>
              </li>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0%"
              }}>
                <NavLink to="/ContactUs"
                  style={{ textDecoration: "none", color: "#0A1229" }}
                  activeStyle={{ fontWeight: "bold" }}
                >Contact</NavLink>
              </li>
              <li style={{
                padding: "10px 0",
                fontFamily: "Open Sans, sans-serif",
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "24px",
                letterSpacing: "0%"
              }}>
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <a
                  href={catalogue}
                  download="Catalogue"
                  style={{
                    backgroundColor: "#1A143A",
                    color: "#ffffff",
                    padding: "10px 24px",
                    borderRadius: "1rem",
                    textDecoration: "none",
                    fontWeight: "600",
                    fontSize: "14px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "all 0.3s ease"
                  }}
                >
                  Catelog
                </a>
              </div>

              </li>
            </ul>
          </div>
      </div>

      {/* <div className='nav-item'> */}
      {/* Navigation Links */}
      {/* <div className='header-nav-bar'> */}


      {/* /////////////////////////////////////////////////////////////////////// */}

      <div className={`header-nav ${middlefix ? "fixed" : ''}`}>
        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>

          {/* <div className='nav-logo'> */}
          <div className={`nav-logo ${showLeftLogo ? "visible" : "hidden"}`}>
            {/* <img src={favcon} className="Nav-logo-icon"/> */}
            <img src={gemnew} alt="Nav-logo" className="Nav-logo" />
          </div>

          <div className='header-nav-list'>
            <NavLink to="/" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px", alignSelf: "flex-end" })} className="nav-item">Home</NavLink>
            <NavLink to="/About" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px", alignSelf: "flex-end" })} className="nav-item">About us</NavLink>
            <div className="products-dropdown" onMouseEnter={toggleProductsDropdown} onMouseLeave={toggleProductsDropdown}>
              <NavLink to="/Products" className="nav-item" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px" })}>Products</NavLink>
              <AiOutlineCaretDown className='dropdownicon' />
              {/* <span class="material-symbols-outlined" className='dropdownicon'>
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e8eaed"><path d="M480-360 280-560h400L480-360Z"/></svg>
              </span> */}

              {productsDropdownOpen && (
                <div className="dropdown-menu">
                  <NavLink to="/TrampolinePark" className="dropdown-item" >Trampoline Park</NavLink>
                  <NavLink to="/IndoorPlayground" className="dropdown-item" >Indoor Playground</NavLink>
                  <NavLink to="/Interactivegames" className="dropdown-item" >Interactive Games</NavLink>
                  <NavLink to="/Climbingwall" className="dropdown-item" >Climbing Wall</NavLink>
                  <NavLink to="/NinjaPark" className="dropdown-item" >Ninja Park</NavLink>
                  <NavLink to="/EntranceSoftware" className="dropdown-item" >Entrance Software</NavLink>
                </div>

              )}

            </div>

            {/* <NavLink to="/Trampoline" style={({ isActive }) => ({fontSize: "16px",alignSelf: "flex-end"})}className="nav-item">E-catelogue</NavLink> */}
            <NavLink to="/Projects" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px", alignSelf: "flex-end" })} className="nav-item">Projects</NavLink>
            <NavLink to="/Roadmap" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px", alignSelf: "flex-end" })} className="nav-item">Roadmap</NavLink>
            {/* <NavLink to="" style={({ isActive }) => ({borderBottom: isActive ? "2px solid yellow" : "none",fontSize: "16px",alignSelf: "flex-end"})}className="nav-item">Blog</NavLink>         */}
            {/* <NavLink to="/Roadmap" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px", alignSelf: "flex-end" })} className="nav-item">Roadmap</NavLink> */}
            <NavLink to="/Blog" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px", alignSelf: "flex-end" })} className="nav-item">Blog</NavLink>
            <NavLink to="/ContactUs" style={({ isActive }) => ({ borderBottom: isActive ? "2px solid yellow" : "none", fontSize: "16px", alignSelf: "flex-end" })} className="nav-item">Contacts</NavLink>
          </div>
        </nav>
      </div>
      {/* </div> */}
    </header>
  );
};

export default Header;